'use client'

import { Text } from '@vinted/web-ui'

import { FormattedRelativeTime } from '@marketplace-web/i18n/i18n-feature'
import { BrazeInboxMessageCardDto } from '@marketplace-web/braze/braze-data'

type Props = {
  card: BrazeInboxMessageCardDto
}

const MessageTime = ({ card: { updated } }: Props) => (
  <div className="u-flexbox u-justify-content-center u-ui-margin-vertical-small">
    <Text as="h4" text={<FormattedRelativeTime value={updated.getTime()} />} type="caption" />
  </div>
)

export default MessageTime
